"use client";

import { ArrowRight, CalendarCheck, ChefHat, PhoneCall, Sparkles } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyForAChange() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const trustSignals = [{
    icon: CalendarCheck,
    label: "Free estimates"
  }, {
    icon: ChefHat,
    label: "Premium finishes"
  }, {
    icon: Sparkles,
    label: "Expert craftsmanship"
  }];
  return <section data-section-id="710" id="ready-for-a-change" className="dark bg-background text-foreground relative min-h-[80vh] w-full overflow-hidden bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699978/img/luxury_interior_painting_finish.png)] bg-cover bg-center bg-fixed">
      {}
      <div className="absolute inset-0 hidden md:block" style={{
      background: "linear-gradient(to right, hsl(190 40% 8% / 0.9) 0%, hsl(190 40% 8% / 0.75) 35%, hsl(190 40% 8% / 0.4) 70%, hsl(190 40% 8% / 0.25) 100%)"
    }} aria-hidden="true" />
      {}
      <div className="absolute inset-0 md:hidden" style={{
      background: "linear-gradient(to bottom, hsl(190 40% 8% / 0.8) 0%, hsl(190 40% 8% / 0.9) 100%)"
    }} aria-hidden="true" />

      {}
      <div className="absolute top-8 right-6 md:top-12 md:right-12 z-20 pointer-events-none">
        <div className="rounded-lg border px-4 py-2 text-[0.7rem] tracking-[0.25em] font-mono uppercase backdrop-blur-sm" style={{
        color: "hsl(22 90% 70%)",
        borderColor: "hsl(22 90% 55% / 0.5)",
        backgroundColor: "hsl(190 40% 8% / 0.4)",
        transform: "rotate(0deg)"
      }}>
          <span className="inline-flex items-center gap-2">
            <span className="inline-block size-1.5 rounded-lg" style={{
            backgroundColor: "hsl(22 90% 55%)"
          }} />
            Booking Now
            <span className="inline-block size-1.5 rounded-lg" style={{
            backgroundColor: "hsl(22 90% 55%)"
          }} />
            2024 Season
            <span className="inline-block size-1.5 rounded-lg" style={{
            backgroundColor: "hsl(22 90% 55%)"
          }} />
          </span>
        </div>
      </div>

      {}
      <div ref={ref} className={`relative z-10 flex min-h-[80vh] items-center px-6 py-24 md:px-12 lg:px-16 md:py-32 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="w-full md:w-3/5 lg:w-1/2 text-center md:text-left">
          {}
          <div className="mb-6 inline-flex items-center gap-3">
            <span className="h-px w-10" style={{
            backgroundColor: "hsl(22 90% 55%)"
          }} aria-hidden="true" />
            <span className="font-mono text-xs tracking-[0.3em] uppercase" style={{
            color: "hsl(22 90% 70%)"
          }}>
              Elite Brushstrokes Painting
            </span>
          </div>

          {}
          <h2 className="font-default font-light leading-[1.05] tracking-tight mb-8" style={{
          color: "hsl(0 0% 98%)",
          fontSize: "clamp(2.75rem, 7vw, 6.5rem)"
        }}>
            Transform your{" "}
            <em className="italic font-normal" style={{
            color: "hsl(22 90% 60%)"
          }}>
              space
            </em>{" "}
            with professional precision.
          </h2>

          {}
          <p className="font-default text-lg md:text-xl leading-relaxed mb-10 max-w-xl mx-auto md:mx-0" style={{
          color: "hsl(210 10% 80%)"
        }}>
            From interior refreshes to exterior transformations, our team delivers 
            flawless results. Schedule your consultation with Elite Brushstrokes 
            today and experience the difference of true craftsmanship.
          </p>

          {}
          <div className="flex flex-col sm:flex-row gap-4 mb-12 items-center md:items-start justify-center md:justify-start">
            <Button asChild size="lg" className="rounded-lg h-14 px-8 text-base font-medium shadow-lg group" style={{
            backgroundColor: "hsl(22 90% 55%)",
            color: "hsl(0 0% 100%)"
          }}>
              <Link to="/GetAQuotePage">
                Request a Free Quote
                <ArrowRight className="ml-1 size-5 transition-transform group-hover:translate-x-1" />
              </Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="rounded-lg h-14 px-8 text-base font-medium bg-transparent backdrop-blur-sm" style={{
            borderColor: "hsl(0 0% 98% / 0.4)",
            color: "hsl(0 0% 98%)"
          }}>
              <Link to="tel:5551233328">
                <PhoneCall className="size-4" />
                Call (555) 123-PAINT
              </Link>
            </Button>
          </div>

          {}
          <div className="flex flex-wrap items-center justify-center md:justify-start gap-x-2 gap-y-4">
            {trustSignals.map((signal, i) => {
            const Icon = signal.icon;
            return <div key={i} data-index={i} className="inline-flex items-center gap-2">
                  <Icon className="size-4" style={{
                color: "hsl(22 90% 70%)"
              }} />
                  <span className="font-mono text-xs tracking-[0.15em] uppercase" style={{
                color: "hsl(210 10% 80%)"
              }}>
                    {signal.label}
                  </span>
                  {i < trustSignals.length - 1 && <span className="mx-3 inline-block size-1 rounded-lg" style={{
                backgroundColor: "hsl(22 90% 55%)"
              }} aria-hidden="true" />}
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}